export const BatchStatus = {
  Available: 'available',
  CheckedOut: 'checked_out',
  Completed: 'completed',
  Deleted: 'deleted',
  Draft: 'draft'
};
